export default __webpack_public_path__ + "alberta-lorry.6a7a1442a99a8c5078ed.svg";